import { render } from "./disconnect-warning.vue?vue&type=template&id=d69e4706&lang=pug"
import script from "./disconnect-warning.vue?vue&type=script&lang=js"
export * from "./disconnect-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__